export default __webpack_public_path__ + "static/jesuit-author-8c318570c044b86cf3934f08057b796b.png";